/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as _galleryRouteImport } from './routes/[_]_gallery'
import { Route as AppRouteImport } from './routes/app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppBillingRouteImport } from './routes/app/billing'
import { Route as AppCallsRouteImport } from './routes/app/calls'
import { Route as AppFilesRouteImport } from './routes/app/files'
import { Route as AppProjectsRouteImport } from './routes/app/projects'
import { Route as AppRequestsRouteImport } from './routes/app/requests'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppWorkRouteImport } from './routes/app/work'
import { Route as InvitationsIdRouteImport } from './routes/invitations/$id'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as StudioIndexRouteImport } from './routes/studio/index'
import { Route as StudioMoneyRouteImport } from './routes/studio/money'
import { Route as ViewPublicIdRouteImport } from './routes/view/$publicId'
import { Route as AppMockupsIndexRouteImport } from './routes/app/mockups/index'
import { Route as AppMockupsRefRouteImport } from './routes/app/mockups/$ref'
import { Route as AppReportsIndexRouteImport } from './routes/app/reports/index'
import { Route as AppReportsPeriodRouteImport } from './routes/app/reports/$period'
import { Route as StudioClientsIndexRouteImport } from './routes/studio/clients/index'
import { Route as StudioClientsSlugRouteImport } from './routes/studio/clients/$slug'
import { Route as StudioClientsNewRouteImport } from './routes/studio/clients/new'
import { Route as StudioMockupsRefRouteImport } from './routes/studio/mockups/$ref'
import { Route as StudioTasksIndexRouteImport } from './routes/studio/tasks/index'
import { Route as StudioTasksRefRouteImport } from './routes/studio/tasks/$ref'
import { Route as StudioWorkOrdersRefRouteImport } from './routes/studio/work-orders/$ref'
import { Route as AppWidgetsWidgetRefIndexRouteImport } from './routes/app/widgets/$widgetRef/index'
import { Route as AppWidgetsWidgetRefConnectRouteImport } from './routes/app/widgets/$widgetRef/connect'
import { Route as AppWidgetsWidgetRefFormsIndexRouteImport } from './routes/app/widgets/$widgetRef/forms/index'
import { Route as AppWidgetsWidgetRefFormsFormKeyRouteImport } from './routes/app/widgets/$widgetRef/forms/$formKey'
import { Route as AppWidgetsWidgetRefFormsNewRouteImport } from './routes/app/widgets/$widgetRef/forms/new'
import { Route as AppWidgetsWidgetRefPostsIndexRouteImport } from './routes/app/widgets/$widgetRef/posts/index'
import { Route as AppWidgetsWidgetRefPostsPostRefRouteImport } from './routes/app/widgets/$widgetRef/posts/$postRef'
import { Route as AppWidgetsWidgetRefSubmissionsIndexRouteImport } from './routes/app/widgets/$widgetRef/submissions/index'
import { Route as AppWidgetsWidgetRefSubmissionsReceiptIdRouteImport } from './routes/app/widgets/$widgetRef/submissions/$receiptId'
import { Route as StudioClientsSlugConnectWidgetRefRouteImport } from './routes/studio/clients/$slug_/connect/$widgetRef'
import { Route as StudioClientsSlugBlogWidgetRefIndexRouteImport } from './routes/studio/clients/$slug_/blog/$widgetRef/index'
import { Route as StudioClientsSlugBlogWidgetRefPostRefRouteImport } from './routes/studio/clients/$slug_/blog/$widgetRef/$postRef'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const _galleryRoute = _galleryRouteImport.update({
  id: '/__gallery',
  path: '/__gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsRoute = AppCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesRoute = AppFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsRoute = AppRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkRoute = AppWorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => AppRoute,
} as any)
const InvitationsIdRoute = InvitationsIdRouteImport.update({
  id: '/invitations/$id',
  path: '/invitations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioIndexRoute = StudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioRoute,
} as any)
const StudioMoneyRoute = StudioMoneyRouteImport.update({
  id: '/money',
  path: '/money',
  getParentRoute: () => StudioRoute,
} as any)
const ViewPublicIdRoute = ViewPublicIdRouteImport.update({
  id: '/view/$publicId',
  path: '/view/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMockupsIndexRoute = AppMockupsIndexRouteImport.update({
  id: '/mockups/',
  path: '/mockups/',
  getParentRoute: () => AppRoute,
} as any)
const AppMockupsRefRoute = AppMockupsRefRouteImport.update({
  id: '/mockups/$ref',
  path: '/mockups/$ref',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsPeriodRoute = AppReportsPeriodRouteImport.update({
  id: '/reports/$period',
  path: '/reports/$period',
  getParentRoute: () => AppRoute,
} as any)
const StudioClientsIndexRoute = StudioClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => StudioRoute,
} as any)
const StudioClientsSlugRoute = StudioClientsSlugRouteImport.update({
  id: '/clients/$slug',
  path: '/clients/$slug',
  getParentRoute: () => StudioRoute,
} as any)
const StudioClientsNewRoute = StudioClientsNewRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => StudioRoute,
} as any)
const StudioMockupsRefRoute = StudioMockupsRefRouteImport.update({
  id: '/mockups/$ref',
  path: '/mockups/$ref',
  getParentRoute: () => StudioRoute,
} as any)
const StudioTasksIndexRoute = StudioTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => StudioRoute,
} as any)
const StudioTasksRefRoute = StudioTasksRefRouteImport.update({
  id: '/tasks/$ref',
  path: '/tasks/$ref',
  getParentRoute: () => StudioRoute,
} as any)
const StudioWorkOrdersRefRoute = StudioWorkOrdersRefRouteImport.update({
  id: '/work-orders/$ref',
  path: '/work-orders/$ref',
  getParentRoute: () => StudioRoute,
} as any)
const AppWidgetsWidgetRefIndexRoute =
  AppWidgetsWidgetRefIndexRouteImport.update({
    id: '/widgets/$widgetRef/',
    path: '/widgets/$widgetRef/',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefConnectRoute =
  AppWidgetsWidgetRefConnectRouteImport.update({
    id: '/widgets/$widgetRef/connect',
    path: '/widgets/$widgetRef/connect',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefFormsIndexRoute =
  AppWidgetsWidgetRefFormsIndexRouteImport.update({
    id: '/widgets/$widgetRef/forms/',
    path: '/widgets/$widgetRef/forms/',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefFormsFormKeyRoute =
  AppWidgetsWidgetRefFormsFormKeyRouteImport.update({
    id: '/widgets/$widgetRef/forms/$formKey',
    path: '/widgets/$widgetRef/forms/$formKey',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefFormsNewRoute =
  AppWidgetsWidgetRefFormsNewRouteImport.update({
    id: '/widgets/$widgetRef/forms/new',
    path: '/widgets/$widgetRef/forms/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefPostsIndexRoute =
  AppWidgetsWidgetRefPostsIndexRouteImport.update({
    id: '/widgets/$widgetRef/posts/',
    path: '/widgets/$widgetRef/posts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefPostsPostRefRoute =
  AppWidgetsWidgetRefPostsPostRefRouteImport.update({
    id: '/widgets/$widgetRef/posts/$postRef',
    path: '/widgets/$widgetRef/posts/$postRef',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefSubmissionsIndexRoute =
  AppWidgetsWidgetRefSubmissionsIndexRouteImport.update({
    id: '/widgets/$widgetRef/submissions/',
    path: '/widgets/$widgetRef/submissions/',
    getParentRoute: () => AppRoute,
  } as any)
const AppWidgetsWidgetRefSubmissionsReceiptIdRoute =
  AppWidgetsWidgetRefSubmissionsReceiptIdRouteImport.update({
    id: '/widgets/$widgetRef/submissions/$receiptId',
    path: '/widgets/$widgetRef/submissions/$receiptId',
    getParentRoute: () => AppRoute,
  } as any)
const StudioClientsSlugConnectWidgetRefRoute =
  StudioClientsSlugConnectWidgetRefRouteImport.update({
    id: '/clients/$slug_/connect/$widgetRef',
    path: '/clients/$slug/connect/$widgetRef',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioClientsSlugBlogWidgetRefIndexRoute =
  StudioClientsSlugBlogWidgetRefIndexRouteImport.update({
    id: '/clients/$slug_/blog/$widgetRef/',
    path: '/clients/$slug/blog/$widgetRef/',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioClientsSlugBlogWidgetRefPostRefRoute =
  StudioClientsSlugBlogWidgetRefPostRefRouteImport.update({
    id: '/clients/$slug_/blog/$widgetRef/$postRef',
    path: '/clients/$slug/blog/$widgetRef/$postRef',
    getParentRoute: () => StudioRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/__gallery': typeof _galleryRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/studio': typeof StudioRouteWithChildren
  '/app/billing': typeof AppBillingRoute
  '/app/calls': typeof AppCallsRoute
  '/app/files': typeof AppFilesRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/requests': typeof AppRequestsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/work': typeof AppWorkRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/studio/money': typeof StudioMoneyRoute
  '/view/$publicId': typeof ViewPublicIdRoute
  '/app/': typeof AppIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/app/mockups/$ref': typeof AppMockupsRefRoute
  '/app/reports/$period': typeof AppReportsPeriodRoute
  '/studio/clients/$slug': typeof StudioClientsSlugRoute
  '/studio/clients/new': typeof StudioClientsNewRoute
  '/studio/mockups/$ref': typeof StudioMockupsRefRoute
  '/studio/tasks/$ref': typeof StudioTasksRefRoute
  '/studio/work-orders/$ref': typeof StudioWorkOrdersRefRoute
  '/app/mockups/': typeof AppMockupsIndexRoute
  '/app/reports/': typeof AppReportsIndexRoute
  '/studio/clients/': typeof StudioClientsIndexRoute
  '/studio/tasks/': typeof StudioTasksIndexRoute
  '/app/widgets/$widgetRef/connect': typeof AppWidgetsWidgetRefConnectRoute
  '/app/widgets/$widgetRef/': typeof AppWidgetsWidgetRefIndexRoute
  '/app/widgets/$widgetRef/forms/$formKey': typeof AppWidgetsWidgetRefFormsFormKeyRoute
  '/app/widgets/$widgetRef/forms/new': typeof AppWidgetsWidgetRefFormsNewRoute
  '/app/widgets/$widgetRef/posts/$postRef': typeof AppWidgetsWidgetRefPostsPostRefRoute
  '/app/widgets/$widgetRef/submissions/$receiptId': typeof AppWidgetsWidgetRefSubmissionsReceiptIdRoute
  '/studio/clients/$slug/connect/$widgetRef': typeof StudioClientsSlugConnectWidgetRefRoute
  '/app/widgets/$widgetRef/forms/': typeof AppWidgetsWidgetRefFormsIndexRoute
  '/app/widgets/$widgetRef/posts/': typeof AppWidgetsWidgetRefPostsIndexRoute
  '/app/widgets/$widgetRef/submissions/': typeof AppWidgetsWidgetRefSubmissionsIndexRoute
  '/studio/clients/$slug/blog/$widgetRef/$postRef': typeof StudioClientsSlugBlogWidgetRefPostRefRoute
  '/studio/clients/$slug/blog/$widgetRef/': typeof StudioClientsSlugBlogWidgetRefIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/__gallery': typeof _galleryRoute
  '/login': typeof LoginRoute
  '/app/billing': typeof AppBillingRoute
  '/app/calls': typeof AppCallsRoute
  '/app/files': typeof AppFilesRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/requests': typeof AppRequestsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/work': typeof AppWorkRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/studio/money': typeof StudioMoneyRoute
  '/view/$publicId': typeof ViewPublicIdRoute
  '/app': typeof AppIndexRoute
  '/studio': typeof StudioIndexRoute
  '/app/mockups/$ref': typeof AppMockupsRefRoute
  '/app/reports/$period': typeof AppReportsPeriodRoute
  '/studio/clients/$slug': typeof StudioClientsSlugRoute
  '/studio/clients/new': typeof StudioClientsNewRoute
  '/studio/mockups/$ref': typeof StudioMockupsRefRoute
  '/studio/tasks/$ref': typeof StudioTasksRefRoute
  '/studio/work-orders/$ref': typeof StudioWorkOrdersRefRoute
  '/app/mockups': typeof AppMockupsIndexRoute
  '/app/reports': typeof AppReportsIndexRoute
  '/studio/clients': typeof StudioClientsIndexRoute
  '/studio/tasks': typeof StudioTasksIndexRoute
  '/app/widgets/$widgetRef/connect': typeof AppWidgetsWidgetRefConnectRoute
  '/app/widgets/$widgetRef': typeof AppWidgetsWidgetRefIndexRoute
  '/app/widgets/$widgetRef/forms/$formKey': typeof AppWidgetsWidgetRefFormsFormKeyRoute
  '/app/widgets/$widgetRef/forms/new': typeof AppWidgetsWidgetRefFormsNewRoute
  '/app/widgets/$widgetRef/posts/$postRef': typeof AppWidgetsWidgetRefPostsPostRefRoute
  '/app/widgets/$widgetRef/submissions/$receiptId': typeof AppWidgetsWidgetRefSubmissionsReceiptIdRoute
  '/studio/clients/$slug/connect/$widgetRef': typeof StudioClientsSlugConnectWidgetRefRoute
  '/app/widgets/$widgetRef/forms': typeof AppWidgetsWidgetRefFormsIndexRoute
  '/app/widgets/$widgetRef/posts': typeof AppWidgetsWidgetRefPostsIndexRoute
  '/app/widgets/$widgetRef/submissions': typeof AppWidgetsWidgetRefSubmissionsIndexRoute
  '/studio/clients/$slug/blog/$widgetRef/$postRef': typeof StudioClientsSlugBlogWidgetRefPostRefRoute
  '/studio/clients/$slug/blog/$widgetRef': typeof StudioClientsSlugBlogWidgetRefIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/__gallery': typeof _galleryRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/studio': typeof StudioRouteWithChildren
  '/app/billing': typeof AppBillingRoute
  '/app/calls': typeof AppCallsRoute
  '/app/files': typeof AppFilesRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/requests': typeof AppRequestsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/work': typeof AppWorkRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/studio/money': typeof StudioMoneyRoute
  '/view/$publicId': typeof ViewPublicIdRoute
  '/app/': typeof AppIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/app/mockups/$ref': typeof AppMockupsRefRoute
  '/app/reports/$period': typeof AppReportsPeriodRoute
  '/studio/clients/$slug': typeof StudioClientsSlugRoute
  '/studio/clients/new': typeof StudioClientsNewRoute
  '/studio/mockups/$ref': typeof StudioMockupsRefRoute
  '/studio/tasks/$ref': typeof StudioTasksRefRoute
  '/studio/work-orders/$ref': typeof StudioWorkOrdersRefRoute
  '/app/mockups/': typeof AppMockupsIndexRoute
  '/app/reports/': typeof AppReportsIndexRoute
  '/studio/clients/': typeof StudioClientsIndexRoute
  '/studio/tasks/': typeof StudioTasksIndexRoute
  '/app/widgets/$widgetRef/connect': typeof AppWidgetsWidgetRefConnectRoute
  '/app/widgets/$widgetRef/': typeof AppWidgetsWidgetRefIndexRoute
  '/app/widgets/$widgetRef/forms/$formKey': typeof AppWidgetsWidgetRefFormsFormKeyRoute
  '/app/widgets/$widgetRef/forms/new': typeof AppWidgetsWidgetRefFormsNewRoute
  '/app/widgets/$widgetRef/posts/$postRef': typeof AppWidgetsWidgetRefPostsPostRefRoute
  '/app/widgets/$widgetRef/submissions/$receiptId': typeof AppWidgetsWidgetRefSubmissionsReceiptIdRoute
  '/studio/clients/$slug_/connect/$widgetRef': typeof StudioClientsSlugConnectWidgetRefRoute
  '/app/widgets/$widgetRef/forms/': typeof AppWidgetsWidgetRefFormsIndexRoute
  '/app/widgets/$widgetRef/posts/': typeof AppWidgetsWidgetRefPostsIndexRoute
  '/app/widgets/$widgetRef/submissions/': typeof AppWidgetsWidgetRefSubmissionsIndexRoute
  '/studio/clients/$slug_/blog/$widgetRef/$postRef': typeof StudioClientsSlugBlogWidgetRefPostRefRoute
  '/studio/clients/$slug_/blog/$widgetRef/': typeof StudioClientsSlugBlogWidgetRefIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/__gallery'
    | '/app'
    | '/login'
    | '/studio'
    | '/app/billing'
    | '/app/calls'
    | '/app/files'
    | '/app/projects'
    | '/app/requests'
    | '/app/settings'
    | '/app/work'
    | '/invitations/$id'
    | '/oauth/consent'
    | '/studio/money'
    | '/view/$publicId'
    | '/app/'
    | '/studio/'
    | '/app/mockups/$ref'
    | '/app/reports/$period'
    | '/studio/clients/$slug'
    | '/studio/clients/new'
    | '/studio/mockups/$ref'
    | '/studio/tasks/$ref'
    | '/studio/work-orders/$ref'
    | '/app/mockups/'
    | '/app/reports/'
    | '/studio/clients/'
    | '/studio/tasks/'
    | '/app/widgets/$widgetRef/connect'
    | '/app/widgets/$widgetRef/'
    | '/app/widgets/$widgetRef/forms/$formKey'
    | '/app/widgets/$widgetRef/forms/new'
    | '/app/widgets/$widgetRef/posts/$postRef'
    | '/app/widgets/$widgetRef/submissions/$receiptId'
    | '/studio/clients/$slug/connect/$widgetRef'
    | '/app/widgets/$widgetRef/forms/'
    | '/app/widgets/$widgetRef/posts/'
    | '/app/widgets/$widgetRef/submissions/'
    | '/studio/clients/$slug/blog/$widgetRef/$postRef'
    | '/studio/clients/$slug/blog/$widgetRef/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/__gallery'
    | '/login'
    | '/app/billing'
    | '/app/calls'
    | '/app/files'
    | '/app/projects'
    | '/app/requests'
    | '/app/settings'
    | '/app/work'
    | '/invitations/$id'
    | '/oauth/consent'
    | '/studio/money'
    | '/view/$publicId'
    | '/app'
    | '/studio'
    | '/app/mockups/$ref'
    | '/app/reports/$period'
    | '/studio/clients/$slug'
    | '/studio/clients/new'
    | '/studio/mockups/$ref'
    | '/studio/tasks/$ref'
    | '/studio/work-orders/$ref'
    | '/app/mockups'
    | '/app/reports'
    | '/studio/clients'
    | '/studio/tasks'
    | '/app/widgets/$widgetRef/connect'
    | '/app/widgets/$widgetRef'
    | '/app/widgets/$widgetRef/forms/$formKey'
    | '/app/widgets/$widgetRef/forms/new'
    | '/app/widgets/$widgetRef/posts/$postRef'
    | '/app/widgets/$widgetRef/submissions/$receiptId'
    | '/studio/clients/$slug/connect/$widgetRef'
    | '/app/widgets/$widgetRef/forms'
    | '/app/widgets/$widgetRef/posts'
    | '/app/widgets/$widgetRef/submissions'
    | '/studio/clients/$slug/blog/$widgetRef/$postRef'
    | '/studio/clients/$slug/blog/$widgetRef'
  id:
    | '__root__'
    | '/'
    | '/__gallery'
    | '/app'
    | '/login'
    | '/studio'
    | '/app/billing'
    | '/app/calls'
    | '/app/files'
    | '/app/projects'
    | '/app/requests'
    | '/app/settings'
    | '/app/work'
    | '/invitations/$id'
    | '/oauth/consent'
    | '/studio/money'
    | '/view/$publicId'
    | '/app/'
    | '/studio/'
    | '/app/mockups/$ref'
    | '/app/reports/$period'
    | '/studio/clients/$slug'
    | '/studio/clients/new'
    | '/studio/mockups/$ref'
    | '/studio/tasks/$ref'
    | '/studio/work-orders/$ref'
    | '/app/mockups/'
    | '/app/reports/'
    | '/studio/clients/'
    | '/studio/tasks/'
    | '/app/widgets/$widgetRef/connect'
    | '/app/widgets/$widgetRef/'
    | '/app/widgets/$widgetRef/forms/$formKey'
    | '/app/widgets/$widgetRef/forms/new'
    | '/app/widgets/$widgetRef/posts/$postRef'
    | '/app/widgets/$widgetRef/submissions/$receiptId'
    | '/studio/clients/$slug_/connect/$widgetRef'
    | '/app/widgets/$widgetRef/forms/'
    | '/app/widgets/$widgetRef/posts/'
    | '/app/widgets/$widgetRef/submissions/'
    | '/studio/clients/$slug_/blog/$widgetRef/$postRef'
    | '/studio/clients/$slug_/blog/$widgetRef/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  _galleryRoute: typeof _galleryRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  StudioRoute: typeof StudioRouteWithChildren
  InvitationsIdRoute: typeof InvitationsIdRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ViewPublicIdRoute: typeof ViewPublicIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__gallery': {
      id: '/__gallery'
      path: '/__gallery'
      fullPath: '/__gallery'
      preLoaderRoute: typeof _galleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/billing': {
      id: '/app/billing'
      path: '/billing'
      fullPath: '/app/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calls': {
      id: '/app/calls'
      path: '/calls'
      fullPath: '/app/calls'
      preLoaderRoute: typeof AppCallsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/files': {
      id: '/app/files'
      path: '/files'
      fullPath: '/app/files'
      preLoaderRoute: typeof AppFilesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/projects': {
      id: '/app/projects'
      path: '/projects'
      fullPath: '/app/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/requests': {
      id: '/app/requests'
      path: '/requests'
      fullPath: '/app/requests'
      preLoaderRoute: typeof AppRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/work': {
      id: '/app/work'
      path: '/work'
      fullPath: '/app/work'
      preLoaderRoute: typeof AppWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/invitations/$id': {
      id: '/invitations/$id'
      path: '/invitations/$id'
      fullPath: '/invitations/$id'
      preLoaderRoute: typeof InvitationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/': {
      id: '/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof StudioIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/money': {
      id: '/studio/money'
      path: '/money'
      fullPath: '/studio/money'
      preLoaderRoute: typeof StudioMoneyRouteImport
      parentRoute: typeof StudioRoute
    }
    '/view/$publicId': {
      id: '/view/$publicId'
      path: '/view/$publicId'
      fullPath: '/view/$publicId'
      preLoaderRoute: typeof ViewPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/mockups/': {
      id: '/app/mockups/'
      path: '/mockups'
      fullPath: '/app/mockups/'
      preLoaderRoute: typeof AppMockupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/mockups/$ref': {
      id: '/app/mockups/$ref'
      path: '/mockups/$ref'
      fullPath: '/app/mockups/$ref'
      preLoaderRoute: typeof AppMockupsRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/reports/': {
      id: '/app/reports/'
      path: '/reports'
      fullPath: '/app/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/reports/$period': {
      id: '/app/reports/$period'
      path: '/reports/$period'
      fullPath: '/app/reports/$period'
      preLoaderRoute: typeof AppReportsPeriodRouteImport
      parentRoute: typeof AppRoute
    }
    '/studio/clients/': {
      id: '/studio/clients/'
      path: '/clients'
      fullPath: '/studio/clients/'
      preLoaderRoute: typeof StudioClientsIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/clients/$slug': {
      id: '/studio/clients/$slug'
      path: '/clients/$slug'
      fullPath: '/studio/clients/$slug'
      preLoaderRoute: typeof StudioClientsSlugRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/clients/new': {
      id: '/studio/clients/new'
      path: '/clients/new'
      fullPath: '/studio/clients/new'
      preLoaderRoute: typeof StudioClientsNewRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/mockups/$ref': {
      id: '/studio/mockups/$ref'
      path: '/mockups/$ref'
      fullPath: '/studio/mockups/$ref'
      preLoaderRoute: typeof StudioMockupsRefRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/tasks/': {
      id: '/studio/tasks/'
      path: '/tasks'
      fullPath: '/studio/tasks/'
      preLoaderRoute: typeof StudioTasksIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/tasks/$ref': {
      id: '/studio/tasks/$ref'
      path: '/tasks/$ref'
      fullPath: '/studio/tasks/$ref'
      preLoaderRoute: typeof StudioTasksRefRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/work-orders/$ref': {
      id: '/studio/work-orders/$ref'
      path: '/work-orders/$ref'
      fullPath: '/studio/work-orders/$ref'
      preLoaderRoute: typeof StudioWorkOrdersRefRouteImport
      parentRoute: typeof StudioRoute
    }
    '/app/widgets/$widgetRef/': {
      id: '/app/widgets/$widgetRef/'
      path: '/widgets/$widgetRef'
      fullPath: '/app/widgets/$widgetRef/'
      preLoaderRoute: typeof AppWidgetsWidgetRefIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/connect': {
      id: '/app/widgets/$widgetRef/connect'
      path: '/widgets/$widgetRef/connect'
      fullPath: '/app/widgets/$widgetRef/connect'
      preLoaderRoute: typeof AppWidgetsWidgetRefConnectRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/forms/': {
      id: '/app/widgets/$widgetRef/forms/'
      path: '/widgets/$widgetRef/forms'
      fullPath: '/app/widgets/$widgetRef/forms/'
      preLoaderRoute: typeof AppWidgetsWidgetRefFormsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/forms/$formKey': {
      id: '/app/widgets/$widgetRef/forms/$formKey'
      path: '/widgets/$widgetRef/forms/$formKey'
      fullPath: '/app/widgets/$widgetRef/forms/$formKey'
      preLoaderRoute: typeof AppWidgetsWidgetRefFormsFormKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/forms/new': {
      id: '/app/widgets/$widgetRef/forms/new'
      path: '/widgets/$widgetRef/forms/new'
      fullPath: '/app/widgets/$widgetRef/forms/new'
      preLoaderRoute: typeof AppWidgetsWidgetRefFormsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/posts/': {
      id: '/app/widgets/$widgetRef/posts/'
      path: '/widgets/$widgetRef/posts'
      fullPath: '/app/widgets/$widgetRef/posts/'
      preLoaderRoute: typeof AppWidgetsWidgetRefPostsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/posts/$postRef': {
      id: '/app/widgets/$widgetRef/posts/$postRef'
      path: '/widgets/$widgetRef/posts/$postRef'
      fullPath: '/app/widgets/$widgetRef/posts/$postRef'
      preLoaderRoute: typeof AppWidgetsWidgetRefPostsPostRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/submissions/': {
      id: '/app/widgets/$widgetRef/submissions/'
      path: '/widgets/$widgetRef/submissions'
      fullPath: '/app/widgets/$widgetRef/submissions/'
      preLoaderRoute: typeof AppWidgetsWidgetRefSubmissionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/widgets/$widgetRef/submissions/$receiptId': {
      id: '/app/widgets/$widgetRef/submissions/$receiptId'
      path: '/widgets/$widgetRef/submissions/$receiptId'
      fullPath: '/app/widgets/$widgetRef/submissions/$receiptId'
      preLoaderRoute: typeof AppWidgetsWidgetRefSubmissionsReceiptIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/studio/clients/$slug_/connect/$widgetRef': {
      id: '/studio/clients/$slug_/connect/$widgetRef'
      path: '/clients/$slug/connect/$widgetRef'
      fullPath: '/studio/clients/$slug/connect/$widgetRef'
      preLoaderRoute: typeof StudioClientsSlugConnectWidgetRefRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/clients/$slug_/blog/$widgetRef/': {
      id: '/studio/clients/$slug_/blog/$widgetRef/'
      path: '/clients/$slug/blog/$widgetRef'
      fullPath: '/studio/clients/$slug/blog/$widgetRef/'
      preLoaderRoute: typeof StudioClientsSlugBlogWidgetRefIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/clients/$slug_/blog/$widgetRef/$postRef': {
      id: '/studio/clients/$slug_/blog/$widgetRef/$postRef'
      path: '/clients/$slug/blog/$widgetRef/$postRef'
      fullPath: '/studio/clients/$slug/blog/$widgetRef/$postRef'
      preLoaderRoute: typeof StudioClientsSlugBlogWidgetRefPostRefRouteImport
      parentRoute: typeof StudioRoute
    }
  }
}

interface AppRouteChildren {
  AppBillingRoute: typeof AppBillingRoute
  AppCallsRoute: typeof AppCallsRoute
  AppFilesRoute: typeof AppFilesRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppRequestsRoute: typeof AppRequestsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppWorkRoute: typeof AppWorkRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMockupsRefRoute: typeof AppMockupsRefRoute
  AppReportsPeriodRoute: typeof AppReportsPeriodRoute
  AppMockupsIndexRoute: typeof AppMockupsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppWidgetsWidgetRefConnectRoute: typeof AppWidgetsWidgetRefConnectRoute
  AppWidgetsWidgetRefIndexRoute: typeof AppWidgetsWidgetRefIndexRoute
  AppWidgetsWidgetRefFormsFormKeyRoute: typeof AppWidgetsWidgetRefFormsFormKeyRoute
  AppWidgetsWidgetRefFormsNewRoute: typeof AppWidgetsWidgetRefFormsNewRoute
  AppWidgetsWidgetRefPostsPostRefRoute: typeof AppWidgetsWidgetRefPostsPostRefRoute
  AppWidgetsWidgetRefSubmissionsReceiptIdRoute: typeof AppWidgetsWidgetRefSubmissionsReceiptIdRoute
  AppWidgetsWidgetRefFormsIndexRoute: typeof AppWidgetsWidgetRefFormsIndexRoute
  AppWidgetsWidgetRefPostsIndexRoute: typeof AppWidgetsWidgetRefPostsIndexRoute
  AppWidgetsWidgetRefSubmissionsIndexRoute: typeof AppWidgetsWidgetRefSubmissionsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,
  AppCallsRoute: AppCallsRoute,
  AppFilesRoute: AppFilesRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppRequestsRoute: AppRequestsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppWorkRoute: AppWorkRoute,
  AppIndexRoute: AppIndexRoute,
  AppMockupsRefRoute: AppMockupsRefRoute,
  AppReportsPeriodRoute: AppReportsPeriodRoute,
  AppMockupsIndexRoute: AppMockupsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppWidgetsWidgetRefConnectRoute: AppWidgetsWidgetRefConnectRoute,
  AppWidgetsWidgetRefIndexRoute: AppWidgetsWidgetRefIndexRoute,
  AppWidgetsWidgetRefFormsFormKeyRoute: AppWidgetsWidgetRefFormsFormKeyRoute,
  AppWidgetsWidgetRefFormsNewRoute: AppWidgetsWidgetRefFormsNewRoute,
  AppWidgetsWidgetRefPostsPostRefRoute: AppWidgetsWidgetRefPostsPostRefRoute,
  AppWidgetsWidgetRefSubmissionsReceiptIdRoute:
    AppWidgetsWidgetRefSubmissionsReceiptIdRoute,
  AppWidgetsWidgetRefFormsIndexRoute: AppWidgetsWidgetRefFormsIndexRoute,
  AppWidgetsWidgetRefPostsIndexRoute: AppWidgetsWidgetRefPostsIndexRoute,
  AppWidgetsWidgetRefSubmissionsIndexRoute:
    AppWidgetsWidgetRefSubmissionsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface StudioRouteChildren {
  StudioMoneyRoute: typeof StudioMoneyRoute
  StudioIndexRoute: typeof StudioIndexRoute
  StudioClientsSlugRoute: typeof StudioClientsSlugRoute
  StudioClientsNewRoute: typeof StudioClientsNewRoute
  StudioMockupsRefRoute: typeof StudioMockupsRefRoute
  StudioTasksRefRoute: typeof StudioTasksRefRoute
  StudioWorkOrdersRefRoute: typeof StudioWorkOrdersRefRoute
  StudioClientsIndexRoute: typeof StudioClientsIndexRoute
  StudioTasksIndexRoute: typeof StudioTasksIndexRoute
  StudioClientsSlugConnectWidgetRefRoute: typeof StudioClientsSlugConnectWidgetRefRoute
  StudioClientsSlugBlogWidgetRefPostRefRoute: typeof StudioClientsSlugBlogWidgetRefPostRefRoute
  StudioClientsSlugBlogWidgetRefIndexRoute: typeof StudioClientsSlugBlogWidgetRefIndexRoute
}

const StudioRouteChildren: StudioRouteChildren = {
  StudioMoneyRoute: StudioMoneyRoute,
  StudioIndexRoute: StudioIndexRoute,
  StudioClientsSlugRoute: StudioClientsSlugRoute,
  StudioClientsNewRoute: StudioClientsNewRoute,
  StudioMockupsRefRoute: StudioMockupsRefRoute,
  StudioTasksRefRoute: StudioTasksRefRoute,
  StudioWorkOrdersRefRoute: StudioWorkOrdersRefRoute,
  StudioClientsIndexRoute: StudioClientsIndexRoute,
  StudioTasksIndexRoute: StudioTasksIndexRoute,
  StudioClientsSlugConnectWidgetRefRoute:
    StudioClientsSlugConnectWidgetRefRoute,
  StudioClientsSlugBlogWidgetRefPostRefRoute:
    StudioClientsSlugBlogWidgetRefPostRefRoute,
  StudioClientsSlugBlogWidgetRefIndexRoute:
    StudioClientsSlugBlogWidgetRefIndexRoute,
}

const StudioRouteWithChildren =
  StudioRoute._addFileChildren(StudioRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  _galleryRoute: _galleryRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  StudioRoute: StudioRouteWithChildren,
  InvitationsIdRoute: InvitationsIdRoute,
  OauthConsentRoute: OauthConsentRoute,
  ViewPublicIdRoute: ViewPublicIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
